import React from 'react'
import { GlobalContainer } from '../container/GlobalContainer'
import styled from '@emotion/styled'
import { ButtonGradient } from '../buttons/button'
import { scrollToNextSection } from './hero.standard'
import { device } from '../../devices'

export const HeroSoftwares = ({intl}) => (
  <Global>
    <ContainerBG>
      <Background/>
    </ContainerBG>
    <GlobalContainer>
      <TitleHero dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.hero_title'})}}
                 data-sal="fade" data-sal-duration="500" data-sal-easing="ease"/>
      <ButtonGradient onClick={scrollToNextSection} data-sal="fade" data-sal-duration="700" data-sal-easing="ease">
        {intl.formatMessage({id: 'software_page.hero_cta'})}
      </ButtonGradient>
    </GlobalContainer>
  </Global>
)


const TitleHero = styled.h1`
  font-size: 2.734vw;
  text-align: left;
  letter-spacing: -0.005vw;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  margin-top: 14.648vw;
  margin-bottom: 2vw;
  width: 71.191vw;
  height: auto;
  color: ${({theme}) => theme.white};
  
  b {
    font-weight: bold;
  }
  
  @media ${device.mobileL} {
    opacity:1;
    animation: inherit;
    font-size: 200%;
    max-width: 100%;
    width: 98%;
    margin-bottom: 20px;
    margin-top: 148px;
  }
`

const ContainerBG = styled.div`
  position: absolute;
  left:0;
  top: 3.906vw;
  z-index: -2;
  @media ${device.mobileL} {
    opacity:1;
    top: -8vw;
  }
`
const Background = styled.div`
  background-color: #0000ff;
  width: 82.910vw;
  height: 41vw;
  clip-path: polygon(100% 0, 100% 85%, 0 100%, 0 15%);
  
  @media ${device.mobileL} {
    height: 700px;
    width:100vw;
  }
`
const Global = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75vh;
  
}
`
